$(document).ready(function () {
    $(".tablinks").click(function () {
        $(".tablinks").removeClass('active');
        $(".info__tabs .section__row .tabcontent .content__row").removeClass('on');
        $(this).addClass('active');
        let activeAttr = $(this).attr('name');
        $(".info__tabs .section__row .tabcontent").find(`[name="${activeAttr}"]`).addClass("on");
    });
});